module.exports = __webpack_public_path__ + "static/media/cloud2.2fcaf213.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Clouds/cloud2.svg
// module id = 529
// module chunks = 0